import React from 'react';

import Loading from './Loading';

const LoadingWrapper = ({ loading, children }) => (
  <div>
    {loading && (
      <div className="c7-spinner--overlay">
        <Loading />
      </div>
    )}
    {children}
  </div>
);

export default LoadingWrapper;
